export const contactsData = {
    email: 'ananyadas1098@gmail.com',
    phone: '7978677784',
    address: 'Kendrapara, pin-754212 ',

    sheetAPI: ''
}